<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <button class="btn btn-warning btn-sm float-right" @click="loadData()"><i class="fa fa-undo"></i>
                    Recarregar dados</button>
                <div class="card shadow mt-5">
                    <!-- Card Header - Accordion -->
                    <a href="#dataGeneralCompany" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="dataGeneralCompany">
                        <h6 class="m-0 font-weight-bold text-primary">Dados gerais
                        </h6>
                    </a>
                    <!-- Card Content - Collapse -->
                    <div class="collapse" id="dataGeneralCompany">
                        <div class="card-body">
                            <form @submit="updateDataCompany">
                                <div class="row">
                                    <div class="col-xl-4 col-md-4 col-sm-12 mt-1">
                                        <label for="">CPF CNPJ*</label>
                                        <div class="input-group mb-3">
                                            <input type="text" class="form-control" placeholder="Ex: xxx.xxx.xxx-xx"
                                                v-model="company.document"
                                                v-mask="['###.###.###-##', '##.###.###/####-##']">
                                        </div>
                                    </div>
                                    <div class="col-xl-8 col-md-8 col-sm-12 mt-1">
                                        <label for="">Nome / Razão Social*</label>
                                        <div class="input-group mb-3">
                                            <input type="text" class="form-control" placeholder="Nome / Razão Social"
                                                v-model="company.corporation_name">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 mt-1">
                                        <label for="">Nome Fantasia</label>
                                        <div class="input-group mb-3">
                                            <input type="text" class="form-control"
                                                placeholder="Nome fantasia (Para empresas)"
                                                v-model="company.fantasy_name">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-6 col-md-6 col-sm-12 mt-1">
                                        <label for="">E-mail</label>
                                        <div class="input-group mb-3">
                                            <input type="text" class="form-control"
                                                placeholder="Ex: usuario@dominio.com" v-model="company.email">
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-md-6 col-sm-12 mt-1">
                                        <label for="">Telefone*</label>
                                        <input type="text" class="form-control" v-model="company.phone"
                                            v-mask="['(##) ####-####', '(##) #####-####']"
                                            placeholder="(xx)x.xxxx-xxxx">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                        <label for="">CEP</label>
                                        <div class="input-group mb-3">
                                            <input type="text" class="form-control" placeholder="Ex: xxxxx-xxx"
                                                v-model="company.zipcode" v-mask="['#####-###']">
                                            <div class="input-group-append">
                                                <button class="btn btn-success" type="button" id="button-addon2"
                                                    @click="searchZipcode()"><i class="fa fa-search"></i>Buscar
                                                    CEP</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-7 col-md-7 col-sm-12 mt-1">
                                        <label for="">Endereço*</label>
                                        <input type="text" class="form-control" placeholder="Ex: Av. Paulista"
                                            v-model="company.street">
                                    </div>
                                    <div class="col-xl-2 col-md-2 col-sm-12 mt-1">
                                        <label for="">Nº</label>
                                        <input type="text" class="form-control" placeholder="Ex: 100"
                                            v-model="company.number_street">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 mt-1">
                                        <label for="">Complemento</label>
                                        <input type="text" class="form-control" placeholder="Ex: Próximo à...."
                                            v-model="company.complement">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-xl-4 col-md-4 col-sm-12 mt-1">
                                        <label for="">Bairro</label>
                                        <input type="text" class="form-control" placeholder="Ex: Centro"
                                            v-model="company.district">
                                    </div>
                                    <div class="col-xl-4 col-md-4 col-sm-12 mt-1">
                                        <label for="">Cidade</label>
                                        <input type="text" class="form-control" placeholder="Ex: São Paulo"
                                            v-model="company.city">
                                    </div>
                                    <div class="col-xl-4 col-md-4 col-sm-12 mt-1">
                                        <label for="">UF</label>
                                        <input type="text" class="form-control" placeholder="Ex: SP"
                                            v-model="company.state">
                                    </div>
                                </div>
                                <button type="submit" class="btn btn-success mt-3"
                                    :disabled='!isDisabledUpdateDataCompany'><i class="fa fa-check"></i>
                                    Atualizar</button>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="card shadow mt-3" v-if="setting_ir == 'true'">
                    <!-- Card Header - Accordion -->
                    <a href="#dataIR" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="dataIR">
                        <h6 class="m-0 font-weight-bold text-primary">Valores IR
                        </h6>
                    </a>
                    <!-- Card Content - Collapse -->
                    <div class="collapse" id="dataIR">
                        <div class="card-body">
                            <form @submit="updateIr">
                                <div class="row mt-2">
                                    <div class="col-xl-12 col-md-12 col-sm-12 mt-1">
                                        <label for="">Valor base* </label>
                                        <input type="text" class="form-control" placeholder="R$ 0,00"
                                            v-model.lazy="ir.base" v-money="money">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-xl-12 col-md-12 col-sm-12 mt-1">
                                        <label for="">Saúde e Educação*</label>
                                        <input type="text" class="form-control" placeholder="R$ 0,00"
                                            v-model.lazy="ir.saude_educacao" v-money="money">
                                    </div>
                                </div>
                                  <div class="row mt-2">
                                    <div class="col-xl-12 col-md-12 col-sm-12 mt-1">
                                        <label for="">Bens e Direitos*</label>
                                        <input type="text" class="form-control" placeholder="R$ 0,00"
                                            v-model.lazy="ir.bens_direitos" v-money="money">
                                    </div>
                                </div>
                                  <div class="row mt-2">
                                    <div class="col-xl-12 col-md-12 col-sm-12 mt-1">
                                        <label for="">Investimentos*</label>
                                        <input type="text" class="form-control" placeholder="R$ 0,00"
                                            v-model.lazy="ir.investimentos" v-money="money">
                                    </div>
                                </div>
                                <button type="submit" class="btn btn-success mt-3"
                                    :disabled='!isDisabledUpdateIr'><i class="fa fa-check"></i>
                                    Atualizar</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api';
import { loadZipcode } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'

export default {
    directives: { mask, money: VMoney },
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {},
            categories: [],
            page: 1,
            last_page: 1,
            total_itens: 0,
            setting_ir: false,
            company: {
                document: '',
                corporation_name: '',
                fantasy_name: '',
                phone: '',
                email: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
                observation: ''
            },
            ir: {
                base: 'R$ 0,00',
                saude_educacao: 'R$ 0,00',
                bens_direitos: 'R$ 0,00',
                investimentos: 'R$ 0,00'
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },
    computed: {
        isDisabledUpdateDataCompany: function () {
            return this.company.document != ''
                && this.company.corporation_name != ''
                && this.company.street != ''
                && this.company.number_street != ''
                && this.company.city != ''
                && this.company.district != ''
                && this.company.state != ''
                && this.company.email != ''
                && this.company.phone != '';
        },
        isDisabledUpdateIr: function () {
            return this.ir.base != 'R$ 0,00'
                && this.ir.saude_educacao != 'R$ 0,00'
                && this.ir.bens_direitos != 'R$ 0,00'
                && this.ir.investimentos != 'R$ 0,00';
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.categories = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.categories = {}
            this.advanced_search_input = {}
            this.loadData();
        },
        formatDecimal(number) {
            return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;

            api.get('/setting/getDataCompany')
                .then((response) => {
                    this.isLoading = false;
                    this.company = response.data.company;
                    const amounts = response.data.ir;
                    for (let ir in amounts) {
                        if (amounts[ir].name == 'base') {
                            this.ir.base = amounts[ir].amount;
                        } else if (amounts[ir].name == 'bens_direitos') {
                            this.ir.bens_direitos = amounts[ir].amount;
                        } else if (amounts[ir].name == 'investimentos') {
                            this.ir.investimentos = amounts[ir].amount;
                        } else if (amounts[ir].name == 'saude_educacao') {
                            this.ir.saude_educacao = amounts[ir].amount;
                        }
                    }

                    console.log(this.ir);
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        searchZipcode() {
            this.isLoading = true;
            if (this.company.zipcode.length > 0) {
                let zipcode = this.company.zipcode.replace(/\D/g, '');
                loadZipcode(zipcode).then((response) => {
                    this.company.street = response.street;
                    this.company.district = response.neighborhood;
                    this.company.city = response.city;
                    this.company.state = response.state;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            } else {
                this.$notify({
                    title: "Informação",
                    text: "Informe um CEP válido",
                    type: 'info'
                });
            }
        },

        updateDataCompany(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.put('/setting/updateDataCompany', this.company)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Dados cadastrais atualizados com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        },

         updateIr(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.put('/setting/updateIrAmount', this.ir)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Dados IR atualizados com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }

    },
    mounted() {
        this.setting_ir = process.env.VUE_APP_IR;
        this.loadData();

    },
}
</script>

<style></style>